// extracted by mini-css-extract-plugin
module.exports = {"search":"Search_search__lBlxj","list":"Search_list__o3w5z","orgName":"Search_orgName__kD1aE","org":"Search_org__85dcH","brick":"Search_brick__Tk_Rt","phone":"Search_phone__AR_TC"};